import { useMutation, useQueryClient } from "@tanstack/react-query";

import { yetakchiAiAPI } from "../api/yetakchiAiAPI";
import { YetakchiAICacheKey } from "../constants/queryKeys";

export const useArchiveChat = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (chatUuid: string) => yetakchiAiAPI.archiveChat(chatUuid),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [YetakchiAICacheKey, "chats"],
      });
    },
  });
};
